import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  border-radius: 8px;
  border: ${(props) => `1px solid ${props.theme.color.light.shadeLighter}; `};
  padding: 16px;
`;
